var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { Psp } from "./../models/V1/Cesop/Psps/Psp";
import { Error as ApiError } from "./../models/V1/Primitives/Error/Error";
export class Psps {
  /**
   * Creates an instance of Psps.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof Psps
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param GetMyPspsRq_ _getMyPspsRq
   * @returns Promise<GetMyPspsRq_>
   * @memberof Psps
   */
  getMyPsps(options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/cesop/Psps", "GET", "application/json; charset=UTF-8", "application/json", options);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200, clazz: Psp, isArray: true }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetPspRq_ _getPspRq
   * @returns Promise<GetPspRq_>
   * @memberof Psps
   */
  getPsp(pGetPspRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/cesop/Psps/{id}", "GET", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "id", value: pGetPspRq.id, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: Psp },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
